import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import './style/global.less';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import Register from './pages/register';
import ResetPassword from './pages/reset-password';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './mock';
import api from '@/utils/api';
const store = createStore(rootReducer);

// 合并登录验证和用户信息获取，只调用一次 /api/user/info
async function checkLoginAndFetchInfo() {
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }
  try {
    // 并行获取用户信息和菜单数据
    const [userInfoRes, menuRes] = await Promise.all([api.get('/api/user/info'), api.get('/api/nav')]);
    if (userInfoRes.data.code !== 200) {
      localStorage.removeItem('token');
      return false;
    }
    const userData = userInfoRes.data.data.user;
    const permissions = userInfoRes.data.data.permissions;
    const companies = userInfoRes.data.data.companies || [];
    const menuData = menuRes.data.data;

    // 存储公司列表到 localStorage
    if (companies.length > 0) {
      localStorage.setItem('companies', JSON.stringify(companies));
      if (!localStorage.getItem('current_company_id') || localStorage.getItem('current_company_id') === 'null') {
        localStorage.setItem('current_company_id', companies[0].id.toString());
        localStorage.setItem('currentCompany', JSON.stringify(companies[0]));
      }
    }
    store.dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: {
          id: userData.id,
          name: userData.name,
          email: userData.email,
          avatar: userData.avatar,
          permissions: permissions,
          menus: menuData
        },
        userLoading: false
      }
    });
    store.dispatch({
      type: 'update-companies',
      payload: {
        companies
      }
    });
    return true;
  } catch (error) {
    localStorage.removeItem('token');
    return false;
  }
}

// 创建一个包装组件来处理异步逻辑
function AppWrapper() {
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [lang, setLang] = useStorage('init-lang', 'en-US');
  const [theme, setTheme] = useStorage('init-theme', 'light');
  useEffect(() => {
    const initApp = async () => {
      // 只调用一次 /api/user/info，同时完成验证和获取用户信息
      const loginStatus = await checkLoginAndFetchInfo();
      setIsLogin(loginStatus);
      setLoading(false);
    };
    initApp();
  }, []);
  function getLocaleInfo() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };

  // 如果还在检查登录状态，显示加载中
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }

  // 检查是否需要重定向到登录页面
  const shouldRedirect = !isLogin && window.location.pathname.replace(/\//g, '') !== 'login' && window.location.pathname.replace(/\//g, '') !== 'register' && window.location.pathname.replace(/\//g, '') !== 'reset-password';

  // 如果需要重定向，跳转到登录页面
  if (shouldRedirect) {
    window.location.href = '/login';
    return null;
  }
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getLocaleInfo(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/register",
    component: Register
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/reset-password",
    component: ResetPassword
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  })))));
}
function Index() {
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(AppWrapper, null));
}
ReactDOM.render(/*#__PURE__*/React.createElement(Index, null), document.getElementById('root'));